import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NbDialogRef } from '@nebular/theme';
import { AuthService } from '../../../services/auth.service';

@Component({
  selector: 'app-registration-complete-dialog',
  templateUrl: './registration-complete-dialog.component.html',
  styleUrl: './registration-complete-dialog.component.scss',
})
export class RegistrationCompleteDialogComponent {
  @Input() email: string = '';

  // False when the account was created but the confirmation mail could not be
  // delivered (SES down, misconfigured IAM, hard bounce). The account exists,
  // so re-registering is impossible — the only way forward is a resend.
  @Input() emailSent: boolean = true;

  resendState: 'idle' | 'sending' | 'sent' | 'error' | 'cooldown' = 'idle';

  constructor(
    public router: Router,
    public dialogRef: NbDialogRef<RegistrationCompleteDialogComponent>,
    private authService: AuthService
  ) {}

  resend(): void {
    if (!this.email || this.resendState === 'sending') {
      return;
    }
    this.resendState = 'sending';
    this.authService.resendConfirmation(this.email).subscribe({
      next: () => (this.resendState = 'sent'),
      error: (err) => {
        // 429 means the cooldown is running; the user only has to wait.
        this.resendState = err?.status === 429 ? 'cooldown' : 'error';
        console.error('[registration-complete] resend failed', err);
      },
    });
  }

  openLoginPage(): void {
    // Redirect to the login page
    this.router.navigate(['/auth/login']);
    // Optionally, you can close the dialog here if needed
    this.dialogRef.close();
  }
}
